<template>
    <button class="button-primary button-primary__transparent button-primary__thin" >
        {{text}}
        <div v-if="iconsReady==true">
            <img style="height: 21px;" v-if="state === 'open'" src="@/assets/lock_open.svg"/>
            <img style="height: 21px" v-if="state === 'claim'" src="@/assets/reserve_ON.png"/>
            <img style="height: 21px" v-if="state === 'activeRet'" src="@/assets/reserve_OFF.png"/>
            <img style="height: 21px" v-if="state === 'oldRet'" src="@/assets/reserve_OFF.png"/>
        </div>
    </button>
</template>

<script>
 export default {
     name: "ReturnsButton",
     props:{
         text:{ type: String, default:'' },
         state:{ type: String, default: 'x' },
         wide:{ type: Boolean, default: false }
     }
 }
</script>

<style scoped>
 .wide {
     width: 100%;
 }
 .wide span {
     flex: 1;
     text-align: left;
 }
</style>
